module.exports = __webpack_public_path__ + "static/media/codeblockBigLogo.4e6e0ee9.png";